module.exports = __webpack_public_path__ + "static/media/explosion.9039b8cf.png";